export const ANIMATION_LOCK = 100
export const BASE_GCD = 2500
